import { create } from 'zustand'

interface AuthState {
  isAuthInitialized: boolean
  setAuthInitialized: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  isAuthInitialized: false,
  setAuthInitialized: () => set({ isAuthInitialized: true }),
}))
